import React from 'react';
import { useParams } from 'react-router-dom';
import AppLayout from '../../layout/app.layout';
import ViewQuizResults from '../../components/quiz/view-results.component';
import PAGE_TITLE_LIST from '../../config/page-title.config';

const QuizResultsView = () => {
  const { id } = useParams();
  const pageTitle = PAGE_TITLE_LIST.QUIZ_RESULTS;

  return (
    <AppLayout pageTitle={pageTitle}>
      <ViewQuizResults id={id} />
    </AppLayout>
  );
};

export default QuizResultsView;
